import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ReportsTableComponent } from './reports-table.component';

const routes: Routes = [
  {
    path: '',
    component: ReportsTableComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReportsTableRoutingModule {}
